import { Link, useRouteLoaderData, useSubmit } from "react-router-dom";
import { field, fieldType, form, SelectOption } from "../types";
export default function FormDetail(){
    const submit = useSubmit();
    function handleDelete(formId:number){
        const ok = window.confirm("Are you sure you want to delete this form?\n\nThis action cannot be undone.");
        if(!ok) return;
        const fd = new FormData();
        fd.append("formId", String(formId));
        submit(fd, {
        method: "post",
        action: "Delete"
        });
    }
    function formatOperator(op: string) {
        switch (op) {
            case "eq": return "=";
            case "notEq": return "≠";
            case "gt": return ">";
            case "gte": return "≥";
            case "lt": return "<";
            case "lte": return "≤";
            case "bt": return "between";
            default: return op;
        }
    }
    function buildFieldMap(fields: field[]) {
        const map = new Map<number, string>();
        for (const f of fields) {
            map.set(f.field_key, f.label || `Field ${f.field_key}`);
        }
        return map;
    }
    const { form, fields } = useRouteLoaderData("form") as {
        form: form;
        fields: field[];
    };
    const rules = form.rules ? JSON.parse(form.rules): [];
    const fieldMap = buildFieldMap(fields);
    return (
        <div className = "cssContent pb8rem">
        <h3>Form Detail</h3>
        <div className = "mb-3">
            <div><strong>ID:</strong> {form.id}</div>
            <div><strong>Name:</strong> {form.name}</div>
            <div><strong>Type:</strong> {form.type}</div>
            <div>
            <strong>Status:</strong>{" "}
            <span className = {`badge bg-${form.status === "published" ? "success" : "secondary"}`}>
                {form.status}
            </span>
            </div>
        </div>
        <h5>Fields</h5>
        {fields.length === 0 ? (
            <div className = "text-muted">No fields defined.</div>
        ) : (
            <table className = "table table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Label</th>
                    <th>Type</th>
                    <th>Required</th>
                    <th>Min</th>
                    <th>Max</th>
                    <th>PlaceHolder</th>
                    <th>Default</th>
                    <th>Options</th>
                    <th>Sub Form</th>
                </tr>
            </thead>
            <tbody>
                {fields.map((field, idx) => (
                <tr key = {field.field_key}>
                    <td>{idx + 1}</td>
                    <td>{field.label}</td>
                    <td>{fieldType[field.field_type]}</td>
                    <td>{!!field.is_required ? "Yes" : "No"}</td>
                    <td>{field.min}</td>
                    <td>{field.max}</td>
                    <td>{field.placeholder}</td>
                    <td>{
                    ["checkbox", "multiSelect"].includes(field.field_type)?
                    (field.default_value as string[] ?? []).join(", "):
                    ["users"].includes(field.field_type)?
                    (field.default_value as SelectOption[] ?? []).map((item:SelectOption, itemIndex:number) => <Link children = {item.label}  key = {itemIndex} to = {`/Users/${item.value}`} className = "me-2"/>):
                    ["user"].includes(field.field_type) && field.default_value?
                    <Link children = {(field.default_value as SelectOption).label} to = {`/Users/${(field.default_value as SelectOption).value}`}/>:
                    field.default_value as string
                    }</td>
                    <td>{field.options && field.options.join(", ")}</td>
                    <td>{field.sub_form_id && <Link children = {field.sub_form_name} to = {`/Forms/Setting/${field.sub_form_id}`}/>}</td>
                </tr>
                ))}
            </tbody>
            </table>
        )}
        <h5 className="mt-4">Rules</h5>
        {rules.length === 0 ? (
            <div className="text-muted">No rules defined.</div>
        ) : (
            <div className="border rounded p-2">
                {rules.map((rule: any, idx: number) => (
                    <div key={rule.id} className="mb-3">
                        <strong>Rule {idx + 1}</strong>

                        <div className="mt-1">
                            <div className="fw-bold">IF</div>
                            <ul className="mb-2">
                                {rule.when.map((cond: any, i: number) => (
                                    <li key={i}>
                                        {fieldMap.get(cond.field_key) ?? `Field ${cond.field_key}`}
                                        {" "}
                                        {formatOperator(cond.operator)}
                                        {" "}
                                        {cond.value?<code>{cond.value}</code>:<>Empty</>}
                                    </li>
                                ))}
                            </ul>

                            <div className="fw-bold">THEN</div>
                            <ul className="mb-0">
                                {rule.then.show?.length > 0 && (
                                    <li>
                                        Show:{" "}
                                        {rule.then.show
                                            .map((id: number) => fieldMap.get(id) ?? `Field ${id}`)
                                            .join(", ")}
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        )}
        <div className = "d-flex gap-2 mt-3">
            <Link
                children = "Edit"
                to = "Edit"
                className = "btn btn-outline-primary"
            />
            <button
                children = "Delete"
                className = "btn btn-danger"
                onClick = {() => handleDelete(form.id)}
            />
            <Link
                children = "Back"
                to = ".."
                relative = "path"
                className = "btn btn-outline-secondary"
            />
        </div>
        </div>
    );
}